// Infinite Scroll Universal - Works for both Collections and Search
// Installation: Add to Assets folder as infinite-scroll.js and include in theme.liquid

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    triggerDistance: 1200,
    showLoader: true,
    loadingText: 'Loading more products...',
    endText: 'No more products to load',
    scrollDebounce: 50,
    hidePagination: true
  };

  let isLoading = false;
  let hasMorePages = true;
  let currentPage = 1;
  let scrollTimer = null;
  let totalPages = null;
  let pageType = null;
  let productGridSelector = null;
  let productItemSelector = null;

  // Detect page type and structure
  function detectPageStructure() {
    const pathname = window.location.pathname;

    if (pathname.includes('/search')) {
      pageType = 'search';
      // Dawn search pages use #product-grid
      productGridSelector = '#product-grid';
      productItemSelector = '.grid__item';
    } else if (pathname.includes('/collections/')) {
      pageType = 'collection';
      // Dawn collection pages use #product-grid
      productGridSelector = '#product-grid';
      productItemSelector = '.grid__item';
    } else {
      return false;
    }

    console.log(`Page type detected: ${pageType}`);
    return true;
  }

  // Initialize infinite scroll
  function init() {
    // Detect page structure
    if (!detectPageStructure()) {
      return;
    }

    // Find the product grid container
    const productGrid = document.querySelector(productGridSelector);

    if (!productGrid) {
      console.log('Product grid not found');
      return;
    }

    console.log('Product grid found:', productGrid);

    // Find pagination - Dawn uses .pagination-wrapper
    const pagination = document.querySelector(
      '.pagination-wrapper .pagination, .pagination'
    );

    if (!pagination) {
      console.log('No pagination found');
      return;
    }

    // Check for next page - Dawn uses aria-label
    const nextLink = pagination.querySelector(
      'a[aria-label*="Next"], .pagination__item a[aria-label*="Next"]'
    );

    if (!nextLink) {
      hasMorePages = false;
      return;
    }

    // Get current page from URL
    const urlParams = new URLSearchParams(window.location.search);
    currentPage = parseInt(urlParams.get('page') || '1');

    // Detect total pages
    totalPages = getTotalPages(pagination);
    console.log(`Starting from page ${currentPage} of ${totalPages || 'unknown'}`);

    // Hide original pagination
    if (CONFIG.hidePagination && pagination) {
      pagination.style.display = 'none';
    }

    // Create loader
    const loader = createLoader();
    productGrid.parentNode.insertBefore(loader, productGrid.nextSibling);

    // Set up scroll listener
    setupScrollListener(productGrid, loader, pagination);
  }

  // Create loading indicator
  function createLoader() {
    const loader = document.createElement('div');
    loader.id = 'infinite-scroll-loader';
    loader.style.cssText = `
      display: none;
      text-align: center;
      padding: 40px;
      font-size: 16px;
      color: #666;
    `;

    loader.innerHTML = `
      <div class="loader-spinner" style="
        display: inline-block;
        width: 40px;
        height: 40px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #333;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 10px;
      "></div>
      <div class="loader-text">${CONFIG.loadingText}</div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;

    return loader;
  }

  // Set up scroll listener
  function setupScrollListener(productGrid, loader, pagination) {
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        handleScroll(productGrid, loader, pagination);
      }, CONFIG.scrollDebounce);
    });

    window.addEventListener('resize', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        handleScroll(productGrid, loader, pagination);
      }, CONFIG.scrollDebounce);
    });
  }

  // Handle scroll event
  function handleScroll(productGrid, loader, pagination) {
    if (isLoading || !hasMorePages) {
      return;
    }

    const scrollPosition = window.scrollY + window.innerHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );

    const triggerPosition = Math.min(
      documentHeight - CONFIG.triggerDistance,
      documentHeight * 0.8,
      documentHeight - (window.innerHeight * 1.5)
    );

    if (scrollPosition >= triggerPosition) {
      loadMoreProducts(productGrid, loader, pagination);
    }
  }

  // Build URL for next page
  function buildNextPageUrl(pageNumber) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', pageNumber);
    return url.toString();
  }

  // Extract total pages from pagination
  function getTotalPages(pagination) {
    const pageLinks = pagination.querySelectorAll('a[href*="page="]');
    let maxPage = 1;

    pageLinks.forEach(link => {
      const match = link.href.match(/page=(\d+)/);
      if (match) {
        const pageNum = parseInt(match[1]);
        if (pageNum > maxPage) {
          maxPage = pageNum;
        }
      }
    });

    const lastLink = pagination.querySelector('[aria-label*="Last"], a[title*="Last"]');
    if (lastLink) {
      const match = lastLink.href.match(/page=(\d+)/);
      if (match) {
        maxPage = parseInt(match[1]);
      }
    }

    return maxPage;
  }

  // Load more products
  async function loadMoreProducts(productGrid, loader, pagination) {
    if (isLoading || !hasMorePages) {
      return;
    }

    isLoading = true;

    if (CONFIG.showLoader) {
      loader.style.display = 'block';
    }

    try {
      currentPage++;
      const nextUrl = buildNextPageUrl(currentPage);

      console.log(`Loading page ${currentPage} from ${nextUrl}`);

      const response = await fetch(nextUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Find new product grid
      const newProductGrid = doc.querySelector(productGridSelector);

      if (newProductGrid) {
        // Get new products
        const newProducts = newProductGrid.querySelectorAll(productItemSelector);

        console.log(`Found ${newProducts.length} products on page ${currentPage}`);

        if (newProducts.length === 0) {
          hasMorePages = false;
        } else {
          // Append products based on page type
          if (pageType === 'search') {
            appendSearchProducts(productGrid, newProducts);
          } else {
            appendCollectionProducts(productGrid, newProducts);
          }

          // Check if we have more pages
          if (totalPages && currentPage >= totalPages) {
            hasMorePages = false;
            console.log(`Reached last page (${currentPage}/${totalPages})`);
          } else if (newProducts.length < 5) {
            hasMorePages = false;
            console.log(`Only ${newProducts.length} products found, assuming last page`);
          } else {
            hasMorePages = true;
            console.log(`Page ${currentPage} loaded. Will continue...`);
          }

          // Update URL
          if (window.history && window.history.replaceState) {
            const newUrl = new URL(window.location);
            newUrl.searchParams.set('page', currentPage);
            window.history.replaceState({page: currentPage}, '', newUrl);
          }

          // Check if should load more immediately
          setTimeout(() => {
            checkIfShouldLoadMore(productGrid, loader, pagination);
          }, 500);
        }
      } else {
        console.log('No product grid found on page ' + currentPage);
        hasMorePages = false;
      }

      // Show end message if no more pages
      if (!hasMorePages) {
        loader.innerHTML = `<div style="padding: 20px; color: #666;">${CONFIG.endText}</div>`;
        setTimeout(() => {
          loader.style.display = 'none';
        }, 3000);
      }

    } catch (error) {
      console.error('Error loading products:', error);
      loader.innerHTML = `<div style="padding: 20px; color: #d00;">Error loading products. Please refresh the page.</div>`;
      setTimeout(() => {
        loader.style.display = 'none';
      }, 3000);
    } finally {
      if (CONFIG.showLoader) {
        loader.style.display = 'none';
      }
      isLoading = false;
    }
  }

  // Append products for search pages
  function appendSearchProducts(productGrid, newProducts) {
    console.log('Appending products for search page');

    // Get reference item for copying classes
    const existingItems = productGrid.querySelectorAll('.grid__item');
    const referenceItem = existingItems[existingItems.length - 1] || existingItems[0];

    newProducts.forEach(product => {
      const productClone = product.cloneNode(true);

      // For search pages, copy ALL classes from reference item
      if (referenceItem) {
        productClone.className = referenceItem.className;

        // Add back any unique product classes
        product.classList.forEach(cls => {
          if ((cls.includes('product') || cls.includes('item')) &&
              !productClone.classList.contains(cls)) {
            productClone.classList.add(cls);
          }
        });
      }

      productGrid.appendChild(productClone);

      // Trigger lazy loading
      if (window.theme && window.theme.Images) {
        window.theme.Images.lazyLoad(productClone);
      }
    });
  }

  // Append products for collection pages
  function appendCollectionProducts(productGrid, newProducts) {
    console.log('Appending products for collection page');

    newProducts.forEach(product => {
      const productClone = product.cloneNode(true);

      // For collection pages, just append as-is (they usually have correct structure)
      productGrid.appendChild(productClone);

      // Trigger lazy loading
      if (window.theme && window.theme.Images) {
        window.theme.Images.lazyLoad(productClone);
      }
    });
  }

  // Check if should load more
  function checkIfShouldLoadMore(productGrid, loader, pagination) {
    if (isLoading || !hasMorePages) {
      return;
    }

    const scrollPosition = window.scrollY + window.innerHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );

    if (documentHeight - scrollPosition < window.innerHeight * 2) {
      loadMoreProducts(productGrid, loader, pagination);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', () => {
    setTimeout(init, 1500);
  });

})();